import {configureStore} from '@reduxjs/toolkit'
import validationReducer from "./reducers/validationReducer";
import translationReducer from "./reducers/translations";
import sidebarReducer from "./reducers/sidebar";
import dashboardReducer from "./reducers/dashboard";
import dataTableSearchReducer from "./reducers/dataTableSearch";
import filtersReducer from "./reducers/filters";

export const store = configureStore({
    reducer: {
        validation: validationReducer,
        translation: translationReducer,
        sidebar: sidebarReducer,
        dashboard: dashboardReducer,
        dataTableSearch: dataTableSearchReducer,
        filters: filtersReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
})

export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
